import { RvoAnimal } from '@tcc-mono/vandijk/shared/data-access/models';
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { APP_CONFIG, IAppConfig } from '@tcc-mono/shared/app-config';
import { BaseService } from '@tcc-mono/shared/data-access';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RvoService extends BaseService<any> {
  public constructor(
    _http: HttpClient,
    @Inject(APP_CONFIG) appConfig: IAppConfig
  ) {
    super(_http, appConfig);
    this.path = 'api/rvo';
  }

  public getRvoInfo = (
    country_code: string,
    identification_number: string,
    animal_species?: string,
  ): Observable<RvoAnimal> => {
    return this.postChild<RvoAnimal>(
      {
        country_code,
        identification_number,
        ...(animal_species ? { animal_species } : {}),
      },
      `animal_info`
    );
  };
}
